import { render, staticRenderFns } from "./Accreditations.vue?vue&type=template&id=5b95be16&"
import script from "./Accreditations.vue?vue&type=script&lang=js&"
export * from "./Accreditations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports